import Pqp from "../../../../../3x1010/Pqp.js";
import Maze from "../../../../maze/Maze.js";
import Decision from "./Decision.js";

export default class RandomMove extends Decision {
	constructor(initer) {
		super(initer);
		this.dir = null;
		this.traveled = 0;
		this.destroyed = false;
	}

	init(payload = null) {
		//setTimeout(this.accomplished.bind(this), 1000);
		let firstChoice = null
		if (payload) {
			firstChoice = payload.data;
		}
		this.startCell = this.mob.cell;
		let lCondExit = false;
		let fuse = 0;
		while (!lCondExit) {
			if (firstChoice) {
				this.dir = firstChoice;
				firstChoice = null;
			} else {
				this.dir = RandomMove.DIRECTIONS[Pqp.rnd(RandomMove.DIRECTIONS.length - 1)];
			}
			this.endCell = this.model.getNearbyCell(this.startCell, this.dir);
			if (this.endCell.canWalk(this.mob)) {
				lCondExit = true;
			}
			fuse++;
			if (fuse > 10) {
				lCondExit = true;
			}
		}
		//this.checking();
		this.inProgress(this);
	}


	checking() {
		if (!this.destroyed) {
			//requestAnimationFrame(this.checkIfReached.bind(this));
			this.checkIfReached();
		}
	}

	/*
	checkIfReached() {
		this.control.stop();
		if (this.control.goto(this.dir)) {
			this.traveled += this.mob.getSpeed();
		}
		if (this.traveled >= this.tileMap.tilew) {
			this.accomplished({ data: this.dir });
		} else {
			//this.checking();
			this.inProgress(this);
		}
	}
	*/


	checkIfReached() {
		let distanceMax = 0;
		this.control.stop();
		if (this.control.goto(this.dir)) {
			// Se si è mosso incrementa la potenziale distanza percorsa
			this.traveled += this.mob.getSpeed();
		}
		if (this.dir === Maze.DIR_S) {
			// arriva da nord
			distanceMax = this.tileMap.tileh;
			//if (this.mob.mc.position().top > this.endCell.tiles[0].position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
			if (this.mob.mc.position().top > this.endCell.position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		if (this.dir === Maze.DIR_N) {
			// arriva da sud
			distanceMax = this.tileMap.tileh;
			//if (this.mob.mc.position().top < this.endCell.tiles[0].position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
			if (this.mob.mc.position().top < this.endCell.position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		if (this.dir === Maze.DIR_E) {
			// arriva da west
			distanceMax = this.tileMap.tilew;
			//if (this.mob.mc.position().left > this.endCell.tiles[0].position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
			if (this.mob.mc.position().left > this.endCell.position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}

		if (this.dir === Maze.DIR_W) {
			// arriva da est
			distanceMax = this.tileMap.tilew;
			//if (this.mob.mc.position().left < this.endCell.tiles[0].position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
			if (this.mob.mc.position().left < this.endCell.position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		//console.log(this.mob.mc,this.traveled , distanceMax + distanceMax / 2);
		//console.log(this.mob.mc, this.destroyed)
		if (this.traveled > distanceMax + distanceMax / 2) {
			// Se ha percorso "troppa" distanza vuol dire che si è incastrato da qualche parte
			this.trackDone(false);
			//console.log(this.mob.mc)
		} else {
			// Non ha ancora raggiunto la cella di destinazione
			//this.checking();
			if (!this.destroyed) {
				this.inProgress(this);
			}
		}

	}

	trackDone(lEsit) {
		this.accomplished({ data: this.dir, reached: lEsit });
	}



}


RandomMove.DIR_N = "n";
RandomMove.DIR_E = "e";
RandomMove.DIR_S = "s";
RandomMove.DIR_W = "w";
RandomMove.DIR_NW = "nw";
RandomMove.DIR_NE = "ne";
RandomMove.DIR_SW = "sw";
RandomMove.DIR_SE = "se";
RandomMove.DIRECTIONS = [RandomMove.DIR_N, RandomMove.DIR_E, RandomMove.DIR_S, RandomMove.DIR_W];